import { useTranslation } from 'react-i18next';
import { Outlet, ScrollRestoration } from 'react-router';

import { Footer } from './Footer';
import { Header } from './Header';
import styles from './Layout.module.css';

/** Публичная часть: главная, каталог, карточка автомобиля, юридические страницы. */
export function PublicLayout() {
  const { t } = useTranslation();

  return (
    <div className={styles.shell}>
      <a className="skip-link" href="#main">
        {t('nav.skipToContent')}
      </a>
      <Header />
      <main id="main" className={styles.main}>
        <Outlet />
      </main>
      <Footer />
      <ScrollRestoration />
    </div>
  );
}
